import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@fgb/core';
import { BadgeStatus } from '@fgb/core';
import { finalize, take } from 'rxjs/operators';
import { ScorecardDescriptionModalComponent } from '@fgb/portal-component-library/src/lib/loyalty/scorecards';
import * as i1 from '@ng-bootstrap/ng-bootstrap';
import * as i4 from '@fgb/portal-component-library/src/lib/directives';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import * as i5 from '@fgb/portal-component-library/src/lib/pipes';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

class BadgeListItemComponent {
    constructor(modalService, scorecardService) {
        this.modalService = modalService;
        this.scorecardService = scorecardService;
        this.phaseThree = false;
        this.BadgeStatus = BadgeStatus;
        this.preventMultipleClick = false;
    }
    ngOnInit() { }
    /**
     * open scorecard description modal.
     */
    openScorecardDescription() {
        if (this.preventMultipleClick)
            return;
        this.preventMultipleClick = true;
        this.scorecardService
            .fetchScorecardBy(this.badge.ScorecardId)
            .pipe(finalize(() => (this.preventMultipleClick = false)), take(1))
            .subscribe((scorecards) => {
            const modalRef = this.modalService.open(ScorecardDescriptionModalComponent, {
                centered: true,
                windowClass: 'scorecard-modal-content',
                backdropClass: 'scorecard-modal-backdrop',
            });
            modalRef.componentInstance.phaseThree = this.phaseThree;
            const scorecard = this.scorecardService.findScorecard(scorecards, this.badge.ScorecardId);
            modalRef.componentInstance.confettiColors = this.confettiColors;
            modalRef.componentInstance.scorecard = scorecard;
            modalRef.componentInstance.parentScorecard = this.scorecardService.findScorecard(scorecards, scorecard.ParentId);
            modalRef.componentInstance.childScoreCard = this.scorecardService.findScorecard(scorecards, scorecard.ChildId);
            modalRef.componentInstance.currentScorecardIndex = this.scorecardService.findScorecardIndex(scorecards, scorecard.ScorecardId);
            modalRef.componentInstance.childScorecardIndex =
                this.scorecardService.findScorecardIndex(scorecards, scorecard.ChildId) || 0;
            modalRef.componentInstance.parentScorecardIndex =
                this.scorecardService.findScorecardIndex(scorecards, scorecard.ParentId) || 0;
            modalRef.componentInstance.linkedScorecardLength = scorecards.length;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgeListItemComponent, deps: [{ token: i1.NgbModal }, { token: i2.ScorecardService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.1", type: BadgeListItemComponent, selector: "fgbcl-badge-list-item", inputs: { badge: "badge", phaseThree: "phaseThree", confettiColors: "confettiColors" }, ngImport: i0, template: "<button type=\"button\" class=\"border-0 bg-transparent w-100 px-0 mt-3\" (click)=\"openScorecardDescription()\">\r\n  <div class=\"badge-container d-flex flex-column justify-content-center align-items-center\">\r\n    <div class=\"badge-image mb-3\" [ngClass]=\"{ 'badge-incomplete': badge.Status != BadgeStatus.Completed }\">\r\n      <img [src]=\"badge.Badge | contentImage: '7':'badge'\" [useDefault]=\"true\" [loyaltyType]=\"'badge'\" alt=\"\" />\r\n    </div>\r\n    <div class=\"badge-title px-1 scorecard-label-ellipsis text-center\">\r\n      {{ badge.Content[0].Name }}\r\n    </div>\r\n  </div>\r\n</button>\r\n", styles: [".badge-container img{height:70px}.badge-incomplete{opacity:.2}.scorecard-label-ellipsis{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}.scorecard-label-ellipsis.three-line{-webkit-line-clamp:3}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.ImgDefaultDirective, selector: "img[useDefault]", inputs: ["src", "useDefault", "loyaltyType"] }, { kind: "pipe", type: i5.ContentImagePipe, name: "contentImage" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgeListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-badge-list-item', template: "<button type=\"button\" class=\"border-0 bg-transparent w-100 px-0 mt-3\" (click)=\"openScorecardDescription()\">\r\n  <div class=\"badge-container d-flex flex-column justify-content-center align-items-center\">\r\n    <div class=\"badge-image mb-3\" [ngClass]=\"{ 'badge-incomplete': badge.Status != BadgeStatus.Completed }\">\r\n      <img [src]=\"badge.Badge | contentImage: '7':'badge'\" [useDefault]=\"true\" [loyaltyType]=\"'badge'\" alt=\"\" />\r\n    </div>\r\n    <div class=\"badge-title px-1 scorecard-label-ellipsis text-center\">\r\n      {{ badge.Content[0].Name }}\r\n    </div>\r\n  </div>\r\n</button>\r\n", styles: [".badge-container img{height:70px}.badge-incomplete{opacity:.2}.scorecard-label-ellipsis{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}.scorecard-label-ellipsis.three-line{-webkit-line-clamp:3}\n"] }]
        }], ctorParameters: () => [{ type: i1.NgbModal }, { type: i2.ScorecardService }], propDecorators: { badge: [{
                type: Input
            }], phaseThree: [{
                type: Input
            }], confettiColors: [{
                type: Input
            }] } });

class BadgeListItemModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgeListItemModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.1", ngImport: i0, type: BadgeListItemModule, declarations: [BadgeListItemComponent], imports: [CommonModule,
            DirectivesModule,
            PipesModule], exports: [BadgeListItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgeListItemModule, imports: [CommonModule,
            DirectivesModule,
            PipesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgeListItemModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BadgeListItemComponent
                    ],
                    imports: [
                        CommonModule,
                        DirectivesModule,
                        PipesModule
                    ],
                    exports: [
                        BadgeListItemComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeListItemComponent, BadgeListItemModule };
